import { TextInputField } from "evergreen-ui";
import { TundraStorefrontSummary } from "../../../../common/models";
import { StoreIDPicker } from "./StoreIDPicker";

export interface ImportThemesFormFieldsProps {
    existingStorefrontId: string;
    themes: string;
    storefrontsData: TundraStorefrontSummary[] | null;
    storefrontsLoading: boolean;
    storefrontsError: Error | undefined;
    updateExistingStorefrontId: (value: string) => void;
    updateThemes: (value: string) => void;
}

export const ImportThemesFormFields = (props: ImportThemesFormFieldsProps) => {
    const {
        themes,
        existingStorefrontId,
        storefrontsData,
        storefrontsLoading,
        storefrontsError,
        updateExistingStorefrontId,
        updateThemes,
    } = props;

    // Update existing store ID state value when a new store ID is selected from the dropdown
    const handleStoreIdSelected = (newValue: string) => {
        updateExistingStorefrontId(newValue);
        updateThemes("");
    };

    // Clear store ID if theme selection fails
    // This is to ensure that the user can re-select a valid store ID
    // This will only occur if the getStorefront query fails.
    const handleThemePickerError = () => {
        updateExistingStorefrontId("");
        updateThemes("");
    };

    return (
        <>
            <p style={{ marginTop: "20px", marginBottom: "30px", lineHeight: "1.7em" }}>
                You can duplicate existing themes from other stores and add them to this store. This
                will not publish these themes. You can also do this later.
            </p>
            {/* This className overrides the colors for labels and required `*` fields in Evergreen UI components */}
            <div className="jc-create-store-custom-input-colors">
                <StoreIDPicker
                    label="Existing Store ID"
                    value={existingStorefrontId}
                    onSelect={handleStoreIdSelected}
                    onInputChange={() => updateThemes("")} // Clear themes when store ID is changed
                    required={false}
                    className="jc-create-store-input"
                    width="620px"
                    storefronts={storefrontsData || undefined}
                    loading={storefrontsLoading}
                    error={storefrontsError}
                />
                <TextInputField
                    name="themes"
                    label="Existing Store Theme(s)"
                    onError={handleThemePickerError} // Clear store ID if theme selection fails to allow re-selection
                    required={false}
                    width="620px"
                    value={themes}
                    className="jc-create-store-input"
                    onChange={(e: any) => updateThemes(e.target.value)}
                />
            </div>
            <p style={{ margin: "0px", lineHeight: "1.7em" }}>
                To find the theme number of an existing theme in Taiga, open it in the editor and
                look at the number at the end of the URL.
            </p>
        </>
    );
};
